import { CaseStudy } from '../../types';

export const mindMeld: CaseStudy = {
  id: '7',
  title: 'Mind Meld',
  category: 'AI Brainstorming Partner',
  imageUrl: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?q=80&w=1200&auto=format&fit=crop',
  description: 'Break through creative blocks with an AI-powered brainstorming companion. Mind Meld synthesizes ideas, generates mind maps, and helps you refine your next big project.',
  screenshots: [],
  comingSoon: true
};